export const DOCX_MIME = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

const escapeHtml = (text) => String(text).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);

export function parseWrapper(wrapper) {
  return (wrapper ?? "")
    .split(">")
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const [tag, ...classes] = part.split(".");
      return { tag, classes };
    });
}

export function wrapFragment(html, wrapper) {
  return parseWrapper(wrapper).reduceRight(
    (inner, { tag, classes }) => `<${tag}${classes.length ? ` class="${classes.join(" ")}"` : ""}>${inner}</${tag}>`,
    html,
  );
}

// Preview and export differ only in where the CSS comes from, so the preview matches the download.
export function buildPage({ html, profile, title, mode }) {
  const hrefs = mode === "export" ? profile.exportCss : profile.css;
  const head = [
    '<meta charset="utf-8">',
    '<meta name="viewport" content="width=device-width, initial-scale=1">',
    `<title>${escapeHtml(title)}</title>`,
    ...hrefs.map((href) => `<link rel="stylesheet" href="${escapeHtml(href)}">`),
    // Imported profiles are untrusted: stop extra CSS closing the <style> element early.
    ...(profile.extraCss ? [`<style>\n${profile.extraCss.replace(/<\/(style)/gi, "<\\/$1")}\n</style>`] : []),
  ];
  const body = wrapFragment(html, profile.exportWrapper || profile.wrapper);
  return `<!doctype html>\n<html lang="en">\n<head>\n${head.join("\n")}\n</head>\n<body>\n${body}\n</body>\n</html>\n`;
}

export function htmlFilename(docName) {
  return `${docName.replace(/\.docx$/i, "")}.html`;
}

export function stylesheetFilename(profile) {
  return `${profile.name.replace(/[\\/:*?"<>|]/g, "-")} sample.docx`;
}
